import { connect } from 'react-redux';
import { beginIntent } from 'redux/modules/intent';
import { RootState } from 'redux/modules/types';

const mapStateToProps = (state: RootState) => ({
  location: state.router.location,
  loggedIn: !!state.auth.user,
});

const mapDispatchToProps = {
  beginIntent,
};

export default connect(mapStateToProps, mapDispatchToProps);

export type ConnectedProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;
